// extracted by mini-css-extract-plugin
export default {"cls1":"CreateComment-cls1__SH","cls2":"CreateComment-cls2__Ph CreateComment-cls1__SH"};